export default class Animation {
    constructor(state) {
        this.state = state;
    }

    start() {
        const animationPreview = document.querySelector('.animated-preview__canvas');
        const PreviewFullScreen = document.querySelector('.fullScreen');
        const fpsRange = document.querySelector('.fps-range');
        const fpsLabel = document.querySelector('.fps-label');
        const btnFullScreen = document.querySelector('.openFullScreen');
        let animatinTime = 1000 / +fpsRange.value;

        fpsRange.value = this.state.fps;
        fpsLabel.innerHTML = `${this.state.fps} fps`;

        const {
            state: { frames }
        } = this;

        let startAnimation = () => {
            let i = 0;
            if (frames.length !== 0) {
                setTimeout(function frame() {
                    animationPreview.style.backgroundImage = frames[i];
                    if (i === frames.length) {
                        i = 0;
                    } else {
                        i += 1;
                    }
                    startAnimation = setTimeout(frame, animatinTime);
                }, animatinTime);
            }
        };

        startAnimation();

        fpsRange.addEventListener('input', e => {
            this.state.fps = +e.target.value;
            fpsLabel.innerHTML = `${this.state.fps} fps`;
            this.state.fps = +e.target.value;
            animatinTime = 1000 / +e.target.value;
        });

        btnFullScreen.addEventListener('click', () => {
            Animation.fullScreen(PreviewFullScreen);
        });
    }

    static fullScreen(element) {
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitrequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.mozRequestFullscreen) {
            element.mozRequestFullScreen();
        }
    }
}
